import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/marketing/content')({
  component: () => <PageStub title="Content Engine" description="Content creation and management" />,
});
